import {
  Typography,
  Stack,
  Tooltip,
  Menu,
  MenuItem,
  Checkbox,
  Radio,
  Paper
} from "@mui/material";
import React, { useEffect } from "react";
import { useEffectOnce } from "react-use";
import {
  getFiles,
  getFile,
  downloadFile,
  getAllUsers,
  getAccessUsers
} from "../store/slices/upload";
import { useDispatch, useSelector } from "react-redux";
import { uploadSelector } from "../store/slices/upload";
import { MaterialReactTable } from "material-react-table";
import _ from "lodash";
import { getExtension, bytesToSize, convertArrayToDictionary, getFolderName, getParentFolderName,getFolderFullName, filterByValues,getIconName,excludeByValues } from "../common/utils";
import moment from "moment/moment";

const getData = (files,groupId) => {  
  let modifiedFiles=_.map(files,file=>{
    return {...file,folderName:getFolderName(file?.parent?.prefix),parentFolderName:getParentFolderName(file?.parent?.prefix,"Upload/"+groupId+"/"),parentPrefix:file?.parent?.prefix}
  })
  let groupedRecords=_.groupBy(modifiedFiles,'folderName')
  if(groupId)
  {
      return groupedRecords[groupId];
  }
  return []
};
const getgroupedData = (fileList,usersDic,groupId,internalGroup) => {
  let filteredRecords=[]
  if(internalGroup.length>0)
  {
      let filesFiltered=[];
      _.map(fileList,file=>{
        if(file.parentPrefix.includes(internalGroup[0].parentPrefix+_.map(internalGroup,'name').join('/')))
        {
          filesFiltered.push(file)
        }
      })
      let modifiedFiles=_.map(filesFiltered,file=>{
        return {...file,folderName:getFolderName(file?.parent?.prefix),parentFolderName:getParentFolderName(file?.parent?.prefix,"Upload/"+groupId+"/"+_.map(internalGroup,'name').join('/')+"/")}
      })
      let groupedRecords=_.groupBy(modifiedFiles,'parentFolderName')
      _.map(groupedRecords,(files,grp)=>{
        if(grp=="")
        {
          _.map(files, (file) => {
          let name = file.name.split("/");
          let user=usersDic[getFolderName(file.name)]
            filteredRecords.push({ name: name[name.length - 1],path:file.name,size:file.properties.length, lastModified:file.properties.lastModified,modifiedBy:user?.Email,ext:getExtension(file.name) });
          });
        }
        else
        {
            let user=usersDic[groupId]
            filteredRecords.push({ name: grp,path:"",size:files.length, lastModified:_.maxBy(files,'properties.lastModified')?.properties?.lastModified,modifiedBy:user?.Email,ext:'folder',files:files,parentPrefix:_.first(files)?.parent?.prefix.split(grp)[0],internalGroup: _.map(internalGroup,'name').join('/')});         
         }     
      })
  }
  else{
      let internalGroupedFolder=_.groupBy(fileList,'parentFolderName')
      let internalFolders=_.compact(_.uniq(_.map(fileList,'parentFolderName')));
      let filteredExternalFiles=excludeByValues(fileList,'parentFolderName',internalFolders)
      _.map(filteredExternalFiles, (file) => { 
        let name = file.name.split("/");
        let user=usersDic[getFolderName(file.name)]
        filteredRecords.push({ name: name[name.length - 1],path:file.name,size:file.properties.length, lastModified:file.properties.lastModified,modifiedBy:user?.Email,ext:getExtension(file.name) });     
      });
      //DirectFolders
      _.map(internalFolders, (item) => {
        let user=usersDic[groupId]
        filteredRecords.push({ name: getFolderFullName(item),path:"",size:internalGroupedFolder[item]?.length, lastModified:_.maxBy(internalGroupedFolder[item],'properties.lastModified')?.properties?.lastModified,modifiedBy:user?.Email,ext:'folder',files:internalGroupedFolder[item],parentPrefix:_.first(internalGroupedFolder[item])?.parent?.prefix.split(item)[0] });         
      });
  }
  return filteredRecords
};
const getFilteredData = (files,selectedUsers,selectedTypes,groupId,sorting) => {
  let data=files;
    if(selectedUsers?.length>0)
    {
      data=  filterByValues(data, 'modifiedBy', _.map(selectedUsers, 'label'))   
    }
    if(selectedTypes?.length>0 && groupId)
    {
      data=  filterByValues(data, 'ext', _.map(selectedTypes, 'label')) 
    }
    if(sorting?.id!=null)
    {
      data=_.orderBy(data,sorting.id,sorting.desc?'asc':'desc')
    }
    else
    {
      data=_.orderBy(data,'lastModified','desc')
    }
  return data;
};
const Welcome = ({selectedRow, setSelectedRow,toggleConfirmationOpen,toggleDocViewer,selectedUser,selectedTypes,groupId,
  rowSelection, setRowSelection,internalGroup, setInternalGroup
}) => {
  const dispatch = useDispatch();

  useEffectOnce(() => {
    dispatch(getFiles(localStorage.getItem("userId")));
    dispatch(getAllUsers());
    dispatch(getAccessUsers(localStorage.getItem("userId")));   
  }, []);
  const { files, users } = useSelector(uploadSelector);
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const [sorting, setSorting] = React.useState([]);
  const open = Boolean(anchorEl);
  //debugger
  //useEffect(()=>{
    //setInternalGroup([]);
  //},[groupId])
  const onRowSelection=(rowId,isFolder,files,currentFolderName)=>{
    if(isFolder)
    {
      const tempFolderSelected=[...rowSelection.folders]
      const tempFilesSelected=[...rowSelection.files]
      const tempMainFoldersSelected=[...rowSelection.mainFolders]
      if(tempFolderSelected.join(" ").includes(rowId+currentFolderName)){
        setRowSelection({...rowSelection,folders:_.filter(tempFolderSelected,it=>{return !_.includes(it,rowId+currentFolderName)}),files:_.filter(tempFilesSelected,it=>!_.includes(it,rowId+currentFolderName)),mainFolders:_.filter(tempMainFoldersSelected,it=>!_.includes(it,rowId+currentFolderName+"/")),isAllSelected:false})
      }
      else{
        let folders=[]
        _.map(files,file=>{
          if(file.parentPrefix.includes(rowId))
          {
            var fullName =file.parentPrefix?.split(rowId);
            var nameList=fullName[1].split("/");
            let n="";
            _.map(_.compact(nameList),(name,index)=>{
              n+=(index==0?name:"/"+name)
              folders.push(rowId+n)
            })
          }
        })
        setRowSelection({...rowSelection,folders:_.concat(tempFolderSelected,folders),files:_.concat(tempFilesSelected,_.map(files,'name')),mainFolders:_.concat(tempMainFoldersSelected,[rowId+currentFolderName+"/"]),isAllSelected:false})
      }
    } 
    else{
      const tempFileSelected=[...rowSelection.files]
      if(_.includes(tempFileSelected,rowId)){
        setRowSelection({...rowSelection,files:_.filter(tempFileSelected,it=>it!==rowId),isAllSelected:false})
      }
      else{
        setRowSelection({...rowSelection,files:_.concat(tempFileSelected,[rowId]),isAllSelected:false})
      }
    }   
  }
  const onAllSelection=(files,isChecked)=>{
    if(isChecked)
    {
      let folders=[]
        _.map(files,file=>{
          if(file.parentPrefix.includes(groupId))
          {
            var fullName =file.parentPrefix?.split(groupId);
            var nameList=fullName[1].split("/");
            let n="";
            _.map(_.compact(nameList),(name,index)=>{
              n+=("/"+name)
              folders.push(fullName[0]+groupId+n)
            })
          }
        })
       let folder=_.uniqBy(_.filter(files,file=>{return !file.parentFolderName==""}),'parentFolderName')
      setRowSelection({...rowSelection,files:_.map(_.filter(files,file=>{return file.parentFolderName==""}),'name'),folders:folders,mainFolders:_.map(folder,'parentPrefix'),isAllSelected:true})
    }
    else
    {
      setRowSelection({ files: [], folders: [] ,mainFolders:[],isAllSelected:false})
    }
  }
  const handleClick = (event,row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow({path:event.currentTarget.id});
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const usersDic = React.useMemo(() => convertArrayToDictionary(users, 'CustomUserId'), [users]);
  const finalData = React.useMemo(() => getData(files,groupId), [files,groupId]);
  const groupedData = React.useMemo(() => getgroupedData(finalData,usersDic,groupId,internalGroup), [files,usersDic,groupId,internalGroup,finalData]);
  const filteredData = React.useMemo(() => getFilteredData(groupedData,selectedUser,selectedTypes,groupId,sorting.length>0?sorting[0]:null), [groupedData,selectedUser,selectedTypes,sorting]);
 
  const onViewClick = (row) => {
    if(row.ext=="folder")
    {
      let internalGroups=_.cloneDeep(internalGroup);
      internalGroups.push(row)
      setInternalGroup(internalGroups)
    }
    else{
      const fileData=[{path:row.path, name:row.name}]
      dispatch(getFile({files: fileData}));
      toggleDocViewer(true);
      setSelectedRow(row);
    }
    
  };
  const onDownloadClick = (path) => {
    let record=_.find(filteredData,{path:selectedRow?.path})
    const fileData=[{path:record.path, name:record.name}]
    dispatch(downloadFile({files: fileData}));
    handleClose()
  };
  const onDeleteClick = (row) => {
    toggleConfirmationOpen();
    handleClose()
  };
  const onEmptyClick=()=>{}
  const paperStyles = {
    root: {
      height: '54px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: `0 ${2} 0 ${2}`,
      margin: '0 auto 7px auto'
    }
  }
  const renderCell = (cell) => {
    switch (cell.column.columnDef.accessorKey) {
      case "name":
        return (
          <Stack direction="row" spacing={2} sx={{justifyContent: "space-between"}}>
            <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "0px" }} className={cell.row.original.ext != "zip" ? "data-link":""} onClick={(e)=>{cell.row.original.ext != "zip" ?onViewClick(cell.row.original):onEmptyClick()}}>
            {cell.renderedCellValue}
          </Typography>
          <div className="ap_delete">
      {cell.row.original.ext !="folder" && <span className="ap_delete"
        id={cell.row.original.path}
        //name={cell.row.original.path}
        aria-controls={Boolean(anchorEl) ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
        onClick={handleClick}//(e)=>{handleClick(e,cell.row.original)}}
        style={{cursor:'pointer'}}
      >
        ...
      </span>}
      <Paper>
      <Menu
        id="basic-menu1"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        keepMounted
        getcontentanchorel={null}
        anchorOrigin={{ vertical: 'bottom',horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={()=>{onDownloadClick(cell.row.original.path)}}>Download</MenuItem>
        <MenuItem onClick={()=>{onDeleteClick(cell.row.original)}}>Delete</MenuItem>
        {/* <MenuItem onClick={()=>{onViewClick(cell.row.original,true)}}>Open</MenuItem> */}
      </Menu>
      </Paper>
      
    </div>
      </Stack>
        );

      case "action":
        return (
          <Stack direction="row" spacing={2}>
            <Tooltip title="Download" placement="bottom">
              <span
                className="data-link"
                onClick={(e) => {
                  onDownloadClick(cell.row.original.path);
                }}
              >
                Download
              </span>
            </Tooltip>
            <Tooltip title="Delete" placement="bottom">
              <span
                className="data-link"
                onClick={(e) => {
                  onDeleteClick(cell.row.original);
                }}
              >
                Delete
              </span>
            </Tooltip>
          </Stack>
        );
      case "size":
          return (
            <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "0px" }}>
              {cell.row.original.ext=="folder"?cell.renderedCellValue+(cell.renderedCellValue>1?" items":" item"):bytesToSize(cell.renderedCellValue)}
            </Typography>
          );
      case "lastModified":
          return (
            <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "0px" }}>
              {cell.renderedCellValue?moment(cell.renderedCellValue).format("MMM DD, YYYY"):""}
            </Typography>
          );
      case "modifiedBy":
          return (
            <Typography sx={{ whiteSpace: "pre-wrap", marginTop: "0px" }}>
              {cell.renderedCellValue}
            </Typography>
          );
      case "folderType":
          return (
              <img src={getIconName(cell.row.original.ext)} height={22} width={22}/>           
            );
    }
  };
 
  const columns = [
    {
      header:<Tooltip title={'Select/Unselect All'} arrow disableInteractive><Checkbox className={rowSelection?.isAllSelected ? "":"ap_delete"} size='small' sx={{padding:0}}
      onChange={(e)=>{onAllSelection(finalData, e.target.checked)}} 
      checked={rowSelection?.isAllSelected}
      /></Tooltip>,
      accessor:'',
      id:'checkbox',
      size: 10,
      Cell:({row})=><Checkbox className={(_.includes(rowSelection.files,row.original.path)||_.includes(rowSelection.folders,(row.original.parentPrefix+row.original.name)))?"":"ap_delete"} checked={_.includes(rowSelection.files,row.original.path)||_.includes(rowSelection.folders,(row.original.parentPrefix+row.original.name))} 
      onChange={()=>{onRowSelection(row.original.ext=='folder'?row.original.parentPrefix:row.original.path,(row.original.ext=='folder'),row.original.files,row.original.name)}} sx={{padding:0}} size='small'/>,
  },
    {
      header: <div className={"fa fa-file-o"} style={{fontSize:20,paddingLeft:3,paddingTop:'8px'}}></div>,
      accessorKey: "folderType",
      id: "folderType",
      size: 10,
      Cell: renderCell,
      enableSorting:false
    },
    {
      header:'Name',
      accessorKey: "name",
      id: "name",
      size: 400,
      Cell: renderCell,
    },
    {
      header:'Modified',
      accessorKey: "lastModified",
      id: "lastModified",
      size: 120,
      Cell: renderCell,
    },
    {
      header:'Modified By',
      accessorKey: "modifiedBy",
      id: "modifiedBy",
      size: 200,
      Cell: renderCell,
    }, 
    {
      header:'Size',
      accessorKey: "size",
      id: "size",
      size: 120,
      Cell: renderCell,
    },
  ];
 const goBack=(name)=>{
    let internalGroups=_.cloneDeep(internalGroup);
    let index=_.findIndex(internalGroups,{name:name})
    setInternalGroup(_.take(internalGroups,index))
 }

  return (
    <>
    <div style={{display:'flex',marginBottom:"5px"}}>  
    {_.map(internalGroup,(ig,index)=>{return <><Typography variant="h5" style={{cursor:'pointer'}} onClick={()=>{goBack(ig?.name)}}>{ig?.name}</Typography>{index!=internalGroup.length-1 &&<Typography variant="h6" style={{paddingLeft:3,paddingRight:3}}>{">"}</Typography>}</>})}  
    </div>
        <MaterialReactTable
          columns={columns}
          data={filteredData ?? []}
          enablePagination={false}
          enableColumnActions={false}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          enableColumnFilters={false}
          enableBottomToolbar={false}
          enableTopToolbar={false}
          enableStickyHeader={true}
          enableSorting={true}
          enableColumnResizing={true}
          columnResizeMode= 'onChange'
          initialState={{ density: "compact" }}
          manualSorting={true}
          state= {{ sorting:sorting }}
          onSortingChange= {setSorting}
          defaultColumn= {{
            maxSize: 400,
            minSize: 50,
            size: 180, //default size is usually 180
          }}
          muiTableContainerProps={{
            sx: {
                height: 'calc(100vh - 187px)',
                overflow: 'auto',
                border: "0"
            }
        }}
          muiTableProps={{
            sx: {
              borderCollapse: "separate",
            },
            className: "fileTable",
          }}
          muiTableHeadProps={{
            sx: {
              top: "0px",
              zIndex: 1,
            },
          }}
          muiTableHeadRowProps={{
            sx: {
              boxShadow: "none",
              height:40
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              border: "1px solid #c5c6c7",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              borderCollapse: "collapse",
              fontSize: "0.875rem",
              color: "#8f9bb3",
              "&:last-child": {
                borderRight: "none",
              },
              "&:first-child": {
                left: '20px',
                marginTop:'5px'
              },
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              border: "1px solid #c5c6c7 ",
              borderLeft: "none",
              borderBottom: "none",
              borderCollapse: "collapse",
              borderRight: "none",
              display:'block',
              "&:last-child": {
                borderRight: "none",
              },
              verticalAlign: "top",
              "&:first-child": {
                left: '20px',
              },
            },
          }}
          muiTableBodyRowProps={({row})=>({      
            onClick:()=>{                          
              //onRowSelection(row.original.name)
            },
            selected:_.includes(rowSelection.files,row.original.path) || _.includes(rowSelection.folders,row.original.path),
            sx: {
              height:40,
              '&:first-of-type > td': {
                borderTop: 'none',
              },
              '&:hover': {
                background: '#e8f3ff',
              },
              '&:hover > td': {
                background: '#e8f3ff',
              },
              '&:last-child > td': {
                borderBottom: '1px solid #c5c6c7',
              },
              cursor:'pointer'
            }
          })}
        />     
    </>
  );
};

export default Welcome;
